<template>
  <footer class="information-footer">
    <div class="container-wrapper">
      <div class="disclaimer-section">
        <p><strong>免責事項:</strong> 本サービスは情報提供のみを目的としており、金融アドバイスや投資勧誘ではありません。株式投資には常にリスクが伴い、過去のパフォーマンスが将来の結果を保証するものではありません。投資判断を行う前に、必ず専門の金融アドバイザーにご相談ください。当社の分析は、利用可能な公開情報に基づいており、100%の正確性を保証するものではありません。過去のパフォーマンスは将来の結果を保証するものではありません</p>
        <p>当サービスは、日本の金融商品取引法および関連法規を遵守しています。本サイトに記載されている情報は、特定の投資商品の購入または売却を勧めるものではなく、投資教育目的でのみ提供されています。</p>
        <p>© 2023 AI Stock Analyzer. All Rights Reserved.</p>
      </div>
      
      <!-- 隐私政策部分 -->
      <div class="terms-section">
        <div class="terms-header">
          <h4>プライバシーポリシー（隐私政策）</h4>
        </div>
        <div class="terms-content active">
          <h5>1. 個人情報の収集（个人信息收集）</h5>
          <p>当社ウェブサイトは、以下の方法で個人情報を収集する場合があります：</p>
          <ul>
            <li>ウェブサイト訪問時の自動収集データ（IPアドレス、ブラウザ情報、デバイス情報など）</li>
            <li>ユーザーが自発的に提供する情報（株式コード、銘柄名、連絡先情報など）</li>
            <li>Cookie技術および類似の追跡技術</li>
          </ul>
          
          <h5>2. 個人情報の利用目的（个人信息使用目的）</h5>
          <p>収集した個人情報は、以下の目的で使用されます：</p>
          <ul>
            <li>リクエストされたサービスの提供（株価分析、市場情報など）</li>
            <li>サービス品質の向上およびユーザーエクスペリエンスのカスタマイズ</li>
            <li>統計分析およびマーケティング調査</li>
            <li>法的要件の遵守</li>
          </ul>
          
          <h5>3. 個人情報の第三者への提供（个人信息第三方共享）</h5>
          <p>当社は、以下の場合を除き、ユーザーの個人情報を第三者と共有しません：</p>
          <ul>
            <li>ユーザーの明示的な同意がある場合</li>
            <li>法的義務を遵守するため</li>
            <li>当社のサービス提供に必要なパートナー企業との共有（データ処理、ホスティングサービスなど）</li>
          </ul>
          
          <h5>4. データセキュリティ（数据安全）</h5>
          <p>当社は、個人情報の安全を確保するために、以下の対策を実施しています：</p>
          <ul>
            <li>SSL暗号化技術の使用</li>
            <li>定期的なセキュリティ監査と評価</li>
            <li>アクセス制限と従業員のトレーニング</li>
            <li>最新のセキュリティ対策の導入</li>
          </ul>
          
          <h5>5. ユーザーの権利（用户权利）</h5>
          <p>ユーザーには以下の権利があります：</p>
          <ul>
            <li>個人情報へのアクセス権</li>
            <li>個人情報の訂正権</li>
            <li>個人情報の削除権（「忘れられる権利」）</li>
            <li>データ処理の制限を求める権利</li>
            <li>データポータビリティの権利</li>
          </ul>
          
          <h5>6. Cookieポリシー（Cookie政策）</h5>
          <p>当ウェブサイトはCookieを使用しています。Cookieとは、ウェブサイトがユーザーのデバイスに保存する小さなテキストファイルで、ウェブサイトがユーザーのブラウザを認識するために使用されます。</p>
          <p>使用されるCookieの種類：</p>
          <ul>
            <li>必須Cookie：ウェブサイトの基本機能に必要</li>
            <li>機能Cookie：ユーザー設定の記憶など、追加機能の提供</li>
            <li>分析Cookie：訪問者のウェブサイト利用状況の分析</li>
            <li>マーケティングCookie：ユーザーの興味に基づいた広告表示</li>
          </ul>
          <p>ブラウザの設定を変更することで、Cookieの使用を制限または無効化することができます。</p>
          
          <h5>7. プライバシーポリシーの更新（隐私政策更新）</h5>
          <p>当社は、プライバシーポリシーを定期的に見直し、必要に応じて更新します。重要な変更がある場合は、ウェブサイト上で通知します。</p>
          
          <h5>8. お問い合わせ（联系我们）</h5>
          <p>プライバシーポリシーに関するご質問やご懸念がある場合は、以下の連絡先にお問い合わせください：</p>
          <p>メール：privacy@aistockanalyzer.jp</p>
          <p>住所：〒100-0004 東京都千代田区大手町1-1-1</p>
        </div>
      </div>
      
      <!-- 服务条款部分 -->
      <div class="terms-section">
        <div class="terms-header">
          <h4>利用規約（服务条款）</h4>
        </div>
        <div class="terms-content active">
          <h5>1. サービス概要（服务概述）</h5>
          <p>AI株価アナライザー（以下「当サービス」）は、人工知能を活用した株価分析ツールを提供するウェブサービスです。当サービスは情報提供のみを目的としており、投資アドバイスや金融商品の推奨を行うものではありません。</p>
          
          <h5>2. 利用資格（使用资格）</h5>
          <p>当サービスを利用するためには、以下の条件を満たす必要があります：</p>
          <ul>
            <li>20歳以上であること</li>
            <li>有効なメールアドレスを持っていること</li>
            <li>本利用規約に同意すること</li>
          </ul>
          
          <h5>3. 登録情報（注册信息）</h5>
          <p>当サービスの利用にあたっては、正確かつ最新の情報を提供する必要があります。登録情報に変更があった場合は、速やかに更新してください。虚偽の情報を提供した場合、アカウントが停止または削除される場合があります。</p>
          
          <h5>4. 知的財産権（知识产权）</h5>
          <p>当サービスのコンテンツ（テキスト、画像、ロゴ、分析データなど）は、当社または当社にライセンスを提供している第三者の知的財産です。これらのコンテンツを無断で複製、配布、修正、公開することは禁止されています。</p>
          
          <h5>5. 利用制限（使用限制）</h5>
          <p>以下の行為は禁止されています：</p>
          <ul>
            <li>法律に違反する目的での利用</li>
            <li>当サービスのセキュリティを侵害する行為</li>
            <li>他のユーザーのアクセスを妨げる行為</li>
            <li>当サービスのサーバーに過度の負荷をかける行為</li>
            <li>当サービスのデータを自動的に収集する行為</li>
          </ul>
          
          <h5>6. 免責事項（免责声明）</h5>
          <p>当サービスは「現状有姿」で提供され、明示または黙示を問わず、いかなる保証も行いません。当社は、当サービスの正確性、完全性、信頼性について保証しません。市場分析や予測は参考情報であり、投資判断は自己責任で行ってください。</p>
          
          <h5>7. 責任制限（责任限制）</h5>
          <p>法律で許される最大限の範囲で、当社は、当サービスの利用または利用不能から生じるいかなる直接的、間接的、付随的、特別、懲罰的、または結果的損害についても責任を負いません。これには、利益の損失、データの損失、営業上の損失が含まれますが、これらに限定されません。</p>
          
          <h5>8. 利用規約の変更（条款变更）</h5>
          <p>当社は、必要に応じて本利用規約を変更する権利を有します。重要な変更がある場合は、当ウェブサイト上で通知します。変更後も当サービスを継続して利用することにより、変更後の利用規約に同意したものとみなされます。</p>
          
          <h5>9. 準拠法および管轄裁判所（适用法律和管辖法院）</h5>
          <p>本利用規約は日本法に準拠し、解釈されるものとします。本利用規約に関連する紛争は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
          
          <h5>10. サービスの変更および終了（服务变更和终止）</h5>
          <p>当社は、予告なく当サービスの内容を変更したり、サービスの提供を一時的または永続的に停止したりする権利を有します。当社は、サービスの変更または終了によって生じるいかなる損害についても責任を負いません。</p>
          
          <h5>11. お問い合わせ（联系方式）</h5>
          <p>本利用規約に関するご質問やご懸念がある場合は、以下の連絡先にお問い合わせください：</p>
          <p>メール：terms@aistockanalyzer.jp</p>
          <p>住所：〒100-0004 東京都千代田区大手町1-1-1</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterInformation'
}
</script>

<style scoped>
.container-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.information-footer {
  margin-top: 20px;
  padding: 15px 0;
  border-top: 1px solid rgba(0, 224, 255, 0.1);
  font-size: 12px;
  color: var(--text-sub);
}

.disclaimer-section {
  max-width: 800px;
  margin: 0 auto;
  padding: 15px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  font-size: 11px;
  line-height: 1.6;
}

/* 隐私政策和服务条款的样式 */
.terms-section {
  margin-top: 20px;
  border: 1px solid rgba(0, 224, 255, 0.2);
  border-radius: 8px;
  overflow: hidden;
  background-color: rgba(0, 22, 56, 0.6);
}

.terms-header {
  padding: 12px 15px;
  background-color: rgba(0, 98, 255, 0.1);
}

.terms-header h4 {
  margin: 0;
  font-size: 16px;
  color: var(--brand-secondary);
}

.terms-content {
  padding: 15px;
}

.terms-content h5 {
  color: var(--brand-secondary);
  margin: 15px 0 8px;
  font-size: 14px;
}

.terms-content p, .terms-content li {
  font-size: 12px;
  color: var(--text-sub);
  margin: 5px 0;
}

.terms-content ul {
  padding-left: 20px;
}
</style> 